var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-container" },
    [
      _c("TheModalLite"),
      _vm._v(" "),
      _c("TheLiteNavbar"),
      _vm._v(" "),
      _c("FullBodyLoader", { attrs: { loadingProgress: _vm.progressPercent } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }